var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "white",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3447 13.5052C11.3447 12.8609 11.571 12.3294 12.0235 11.9107C12.476 11.4919 13.0642 11.2825 13.7882 11.2825C14.4993 11.2825 15.0746 11.4887 15.5142 11.901C15.9667 12.3262 16.1929 12.8803 16.1929 13.5632C16.1929 14.1817 15.9731 14.697 15.5336 15.1094C15.0811 15.5346 14.4864 15.7472 13.7494 15.7472H13.73C13.019 15.7472 12.4437 15.5346 12.0041 15.1094C11.5645 14.6842 11.3447 14.1494 11.3447 13.5052ZM11.5968 30.4167V17.506H15.902V30.4167H11.5968ZM18.2873 30.4167H22.5925V23.2076C22.5925 22.7566 22.6443 22.4087 22.7477 22.1639C22.9287 21.7258 23.2034 21.3553 23.5719 21.0526C23.9403 20.7498 24.4025 20.5984 24.9585 20.5984C26.4065 20.5984 27.1304 21.5712 27.1304 23.5168V30.4167H31.4356V23.0143C31.4356 21.1073 30.9831 19.661 30.0781 18.6753C29.1731 17.6896 27.9773 17.1967 26.4905 17.1967C24.8227 17.1967 23.5234 17.9119 22.5925 19.3421V19.3807H22.5731L22.5925 19.3421V17.506H18.2873C18.3132 17.9183 18.3261 19.2003 18.3261 21.3521C18.3261 23.5039 18.3132 26.5254 18.2873 30.4167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/LinkedIn-icon.2e872a54192db863f597967b218f1181.svg";
export { ForwardRef as ReactComponent };